import { jsPDF } from "jspdf";

const KURUM =
  "LULUS ARTISAN FIRIN GIDA SANAYI VE TICARET ANONIM SIRKETI";

const ADRES_MAX = 80;
const TELEFON_MAX = 11;

const BELGE_TIPLERI = {
  yillik_izin: {
    baslik: "YILLIK İZİN DİLEKÇESİ",
    konu: "Yıllık İzin Talebi",
    aciklama:
      "Yukarıda bilgileri verilen çalışan olarak, yasal haklarım çerçevesinde yıllık izin kullanmak istediğimi arz ederim.",
    dosyaOnEk: "Yillik_Izin_Dilekcesi",
  },
  ucretsiz_izin: {
    baslik: "ÜCRETSİZ İZİN DİLEKÇESİ",
    konu: null,
    aciklama:
      "Yukarıda bilgileri verilen çalışan olarak, yasal haklarım çerçevesinde ücretsiz izin kullanmak istediğimi arz ederim.",
    dosyaOnEk: "Ucretsiz_Izin_Dilekcesi",
  },
};

let fontsReady = null;

function formatTrDate(yyyyMmDd) {
  if (!yyyyMmDd) return "";
  const [y, m, d] = yyyyMmDd.split("-");
  return `${d}.${m}.${y}`;
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  const chunk = 0x8000;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

async function loadFonts(doc) {
  if (!fontsReady) {
    fontsReady = (async () => {
      const [regularBuf, boldBuf] = await Promise.all([
        fetch(`${process.env.PUBLIC_URL || ""}/fonts/DejaVuSans.ttf`).then((r) => {
          if (!r.ok) throw new Error("PDF fontu yüklenemedi (DejaVuSans).");
          return r.arrayBuffer();
        }),
        fetch(`${process.env.PUBLIC_URL || ""}/fonts/DejaVuSans-Bold.ttf`).then((r) => {
          if (!r.ok) throw new Error("PDF fontu yüklenemedi (DejaVuSans-Bold).");
          return r.arrayBuffer();
        }),
      ]);
      return {
        regular: arrayBufferToBase64(regularBuf),
        bold: arrayBufferToBase64(boldBuf),
      };
    })();
  }

  const fonts = await fontsReady;
  doc.addFileToVFS("DejaVuSans.ttf", fonts.regular);
  doc.addFileToVFS("DejaVuSans-Bold.ttf", fonts.bold);
  doc.addFont("DejaVuSans.ttf", "DejaVuSans", "normal");
  doc.addFont("DejaVuSans-Bold.ttf", "DejaVuSans", "bold");
}

/**
 * İzin dilekçesini PDF olarak indirir.
 * Tarihler forma girildiği gibi yazılır (İş Başı = seçilen bitiş tarihi).
 * Database'e kayıt yapmaz.
 */
export async function generateIzinBelgesi({
  tip,
  adSoyad,
  gorev,
  tcKimlik,
  telefon,
  adres,
  baslangic,
  bitis,
  sure,
}) {
  const meta = BELGE_TIPLERI[tip];
  if (!meta) {
    throw new Error("Bu izin tipi için belge oluşturulamaz.");
  }

  const adresClean = String(adres || "").trim().slice(0, ADRES_MAX);
  const telefonClean = String(telefon || "").replace(/\D/g, "").slice(0, TELEFON_MAX);
  const safeName = (adSoyad || "calisan")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^a-zA-Z0-9çÇğĞıİöÖşŞüÜ_-]/g, "");

  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
  await loadFonts(doc);

  const left = 20;
  const right = 190;
  const maxWidth = right - left;
  let y = 24;

  const setNormal = (size = 11) => {
    doc.setFont("DejaVuSans", "normal");
    doc.setFontSize(size);
  };
  const setBold = (size = 11) => {
    doc.setFont("DejaVuSans", "bold");
    doc.setFontSize(size);
  };

  const line = (label, value) => {
    setBold(11);
    const labelText = `${label} `;
    doc.text(labelText, left, y);
    const labelW = doc.getTextWidth(labelText);
    setNormal(11);
    const valueLines = doc.splitTextToSize(String(value ?? ""), maxWidth - labelW);
    doc.text(valueLines, left + labelW, y);
    y += Math.max(1, valueLines.length) * 6.2;
  };

  setBold(16);
  doc.text(meta.baslik, 105, y, { align: "center" });
  y += 14;

  line("Kurum/Kuruluş :", KURUM);
  line("Adı Soyadı :", adSoyad || "");
  line("TC Kimlik Numarası :", tcKimlik || "");
  line("Telefon Numarası :", telefonClean || "");
  line("Adres :", adresClean || "");
  line("Görevi :", gorev || "");

  y += 4;
  if (meta.konu) {
    line("Konu :", meta.konu);
  }

  setBold(11);
  doc.text("Açıklamalar :", left, y);
  y += 7;
  setNormal(11);
  const aciklamaLines = doc.splitTextToSize(meta.aciklama, maxWidth);
  doc.text(aciklamaLines, left, y);
  y += aciklamaLines.length * 6.2 + 4;

  line("İzin Süresi :", sure != null ? `${sure} gün` : "");
  line("İzin Başlangıç Tarihi :", formatTrDate(baslangic));
  line("İş Başı Tarihi :", formatTrDate(bitis));

  y += 4;
  setNormal(11);
  doc.text("Bilgilerinize arz ederim.", left, y);
  y += 16;

  const col1 = left;
  const col2 = 110;

  setBold(11);
  doc.text("İzin Talep Eden", col1, y);
  doc.text("Yönetici Onayı", col2, y);
  y += 10;

  setNormal(11);
  doc.text("İmza : _________________________", col1, y);
  doc.text("İmza : _________________________", col2, y);
  y += 8;
  doc.text(`Ad Soyad : ${adSoyad || "_________________________"}`, col1, y);
  doc.text("Ad Soyad : _________________________", col2, y);

  const filename = `${meta.dosyaOnEk}_${safeName || "belge"}.pdf`;
  const blob = doc.output("blob");
  const file = new File([blob], filename, { type: "application/pdf" });

  // Telefonda sadece dosya paylaş (url/bağlantı ekleme)
  if (typeof navigator !== "undefined" && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: filename });
      return;
    } catch (err) {
      // Kullanıcı iptal ettiyse indirme yapma
      if (err?.name === "AbortError") return;
      // Share başarısızsa indirmeye düş
    }
  }

  doc.save(filename);
}

/** @deprecated use generateIzinBelgesi({ tip: "yillik_izin", ... }) */
export async function generateYillikIzinBelgesi(payload) {
  return generateIzinBelgesi({ tip: "yillik_izin", ...payload });
}

export async function generateUcretsizIzinBelgesi(payload) {
  return generateIzinBelgesi({ tip: "ucretsiz_izin", ...payload });
}

export { ADRES_MAX, TELEFON_MAX, BELGE_TIPLERI };
